// @ts-nocheck

export type TenantGetWithRoomPlans = typeof TenantGetWithRoomPlans[keyof typeof TenantGetWithRoomPlans];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithRoomPlans = {
  true: 'true',
  false: 'false',
} as const;
